export default {_name:'image',module:'Field',view:'Element/Image',options:{key:'image',ms:3,sm:3,xs:12}}